import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/OrganizationHealthMonitoringResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/monitoring`;
	}
	getThrottlingData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/searchapi/usage/throttling`, {
			from: e.from,
			to: e.to
		}));
	}
	getTotalQueriesData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/searchapi/query-pipelines/usage/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getAverageResponseTimesData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/searchapi/query-pipelines/usage/performance/average`, {
			from: e.from,
			to: e.to
		}));
	}
	getLimits(e) {
		let t = this.buildPath(`${n.baseUrl}/platform/limits`);
		if (e && e.length > 0) {
			let n = e.map((e) => `limitKeyRequests=${e}`).join("&");
			return this.api.get(`${t}?${n}`);
		}
		return this.api.get(t);
	}
	getTotalIndexedItems(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/index/items/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getStreamAPITotalRequests(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/streamapi/usage/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getStreamAPILoads(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/streamapi/usage/loads`, {
			from: e.from,
			to: e.to
		}));
	}
	getPushAPITotalRequests(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/pushapi/usage/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getPushAPITotalProcessedItems(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/pushapi/items/processed/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getStreamAPIThrottlingData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/streamapi/usage/throttling`, {
			from: e.from,
			to: e.to
		}));
	}
	getPushAPIThrottlingData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/pushapi/usage/throttling`, {
			from: e.from,
			to: e.to
		}));
	}
	getIPEMetricsTotal(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/performancemonitoring/ipe-metrics/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getIPEMetricsSummarize(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/performancemonitoring/ipe-metrics/summarize`, {
			from: e.from,
			to: e.to
		}));
	}
	getAverageIndexingProcessingTime() {
		return this.api.get(this.buildPath(`${n.baseUrl}/performancemonitoring/indexing/processing-time`));
	}
	getIndexingProcessingTimeHistory(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/performancemonitoring/indexing/processing-time/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getCrawlerTotalProcessedItems(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/crawler/items/total`, {
			from: e.from,
			to: e.to
		}));
	}
	getQPSData(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/searchapi/usage/qps`, {
			from: e.from,
			to: e.to
		}));
	}
	getTotalEvents(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/events/total`, {
			from: e.from,
			to: e.to
		}));
	}
};
//#endregion
export { n as OrganizationHealthMonitoringResource };

//# sourceMappingURL=OrganizationHealthMonitoringResource.js.map